import PropTypes from 'prop-types';

export const DealersInsightsDateRangeType = PropTypes.shape({
  error: PropTypes.any,
});

/**
 * @typedef {Object} DateRangeData
 * @property {any} error
 */

const dateRangeInitialState = {
  error: null,
};

export const defaultState = () => dateRangeInitialState;
